import { Outlet } from 'react-router-dom';

import EquipmentTabs from 'components/EquipmentTabs';
import TabContainer from 'components/containers/TabContainer';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EquipmentDetails: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { TITLE } = useTranslation();

    return (
        <TabContainer testId={testId} title={TITLE}>
            <EquipmentTabs className={styles.equipmentTabs} />

            <Outlet />
        </TabContainer>
    );
};

export default EquipmentDetails;
